import { render, staticRenderFns } from "./SaleShippings.vue?vue&type=template&id=6aa3f3be&"
import script from "./SaleShippings.vue?vue&type=script&lang=js&"
export * from "./SaleShippings.vue?vue&type=script&lang=js&"
import style0 from "./SaleShippings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports